<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-13 11:39:19
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-13 11:43:35
 * @FilePath: /chaoyongtuan/src/views/sampleOrder/importLog/tableCells/statusCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
		<a v-if="row.file_url" :href="row.file_url" class="ml-4 cursor-pointer yx-color-primary">导出失败数据</a>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
	computed: {},
	methods: {
	},
	components: {},
};
</script>
<style lang="less" scoped>

</style>
